export default "/assets/images/filter-CC.png?9604eecaaa4463d38f4cf743be799cbf";